import FilterHeader from "../../components/FilterHeader";
import FilterFavourites from "../../components/FilterFavourites";

const Favourites = () => {
  return (
    <>
      <FilterHeader />
      <FilterFavourites />
    </>
  );
};

export default Favourites;
